import React, { Component } from "react";
import { connect } from "react-redux";
import "../Home.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { bindActionCreators } from "redux";
import moment from "moment";
import ComboboxInput from "../PushInteractive/ComboboxInputCustom";
import { fromJS } from "immutable";
import { ClientId, PrevilageId, SenderId } from "../../helper/HelperAuth";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionGetSmartMarketing from "../../store/action/SmartMarketing/Fetch";
import { toast } from "react-toastify";
import ActionFetchTemplate from "../../store/action/TemplateHsm/Fetch";
import ActionGetAccessModule from "../../store/action/AccessModule/Fetch";
import ActionGetClient from "../../store/action/Client/FetchAll";
import ActionFindByGroupId from "../../store/action/Previlage/FindByGroupId";
import { Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";

moment.locale('en');
moment.defaultFormat = "YYYY-MM-DD";
class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Push Dashboard",
      isadmin: false,
      dates:
        moment().format("D MMMM YYYY") + " - " + moment().format("D MMMM YYYY"),
      form: fromJS({
        "client": ClientId,
        "sender": SenderId,
        "tanggal-mulai": moment().format("MM/D/YYYY"),
        "tanggal-selesai": moment().format("MM/D/YYYY"),
        "template-id": "",
      }),
      hidecliet: "hide",
      initstart: moment().format("MM/D/YYYY"),
      initend: moment().format("MM/D/YYYY"),
      startDate: "",
      endDate: "",
      intertotick: 0,
      interinquiry: 0,
      interaverage: 0,
      tooltip: "",
      dissender: true,
      errors: fromJS({}),
      dataSmartMarketing: fromJS({
        marketing_messages_sent: 0,
        marketing_messages_delivered: 0,
        marketing_messages_read: 0,
        marketing_messages_link_btn_click: 0,
        marketing_messages_delivery_rate: 0,
        marketing_messages_read_rate: 0,
        marketing_messages_link_btn_click_rate: 0,
        marketing_messages_read_rate_benchmark: 0,
        marketing_messages_click_rate_benchmark: 0,
        unique_clicks: 0,      }),
      loaderStyle: {},
      actionid: "",
      colhide: '"forms-groups cols-sm-6"',
      datePickerKey: Date.now(),
      currentDate: moment().format('YYYY-MM-DD'),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCallback = this.handleCallback.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.refreshDateRangePicker = this.refreshDateRangePicker.bind(this);
    this.setDefaultSmartMarketingData = this.setDefaultSmartMarketingData.bind(this);
    this.setSmartMarketingData = this.setSmartMarketingData.bind(this);
  }

  handleActionId() {
    let array = [];
    let action = 0;
    let menuPrev =
      this.props.accessmodules.get("data") != null
        ? this.props.accessmodules.get("data")
        : fromJS([]);
    {
      menuPrev.map((data, i) =>
        array.push({
          "menu-name": data.get("menu-name"),
          "action-id": data.get("action-id"),
        })
      );
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i]["menu-name"] === "Push Summary") {
        action = array[i]["action-id"];
        this.state.action_id = array[i]["action-id"];
      }
    }
    return action;
  }

  async handleChange(field, value, label) {
    var formVal = this.state.form;
    let newDate = new Date();

    let startDate = newDate.getDate();
    let endDate = newDate.getDate();

    if (formVal.get("tanggal-mulai") !== "") {
      startDate = formVal.get("tanggal-mulai");
    }

    if (formVal.get("tanggal-selesai") !== "") {
      endDate = formVal.get("tanggal-selesai");
    }

    if (value == null) {
      value = "";
    }
    if (field == "client") {
      if (value == "") {
        toast.warn("Client cannot be empty");
        return false;
      } else {
        this.props.actionGetAllSender(value);
        this.props.actionFetchTemplate(value);
      }

      formVal = formVal.set("sender", "");
    }
    if (field == "sender") {
      if (value == "") {
        toast.warn("Sender cannot be empty");
        return false;
      }
      if (this.state.actionid == 5) {
        if (PrevilageId == 1 || this.state.isadmin == true)
          this.props.actionFetchTemplate(formVal.get("client"), value, 5);
        else this.props.actionFetchTemplate(ClientId, value, 5);
      } else {
        if (PrevilageId == 1 || this.state.isadmin == true)
          this.props.actionFetchTemplate(formVal.get("client"), value);
        else this.props.actionFetchTemplate(ClientId, value);
      }
    }

    formVal = formVal.set(field, value);
    this.setState({ form: formVal });
  }

  async handleSearch(dispatch) {
    this.setState({
      loaderStyle: {},
    });
    var formVal = this.state.form;
    var validationError = false;

    // Validasi semua field required
    if (formVal.get("client") == "") {
      toast.warn("Client cannot be empty");
      validationError = true;
    }
    if (formVal.get("sender") == "") {
      toast.warn("Sender cannot be empty");
      validationError = true;
    }
    if (formVal.get("template-id") == "") {
      toast.warn("Template cannot be empty");
      validationError = true;
    }

    if (validationError) {
      this.setState({ loaderStyle: { display: "none" } });
      return false;
    }
    
    var body = {
      "clientId": formVal.get("client"),
      "sender": formVal.get("sender"),
      "startDate": moment(formVal.get("tanggal-mulai"), "MM/D/YYYY").format("YYYY-MM-DD"),
      "endDate": moment(formVal.get("tanggal-selesai"), "MM/D/YYYY").format("YYYY-MM-DD"),
      "templateId": formVal.get("template-id"),
    };

    try {
      let response = await this.props.actionGetSmartMarketing(body);
      // Cek apakah ada error dari API
      if (response && response.get("error")) {
        const errorMsg =
          response.get("error").get("message") || "Unknown error occurred";
        toast.error(`Error: ${errorMsg}`);

        // Jika ada error tapi masih ada data, tetap proses datanya
        if (response.get("data") && response.get("data").size > 0) {
          const apiData = response.get("data").get(0);
          this.setSmartMarketingData(apiData);
        } else {
          // Jika ada error dan tidak ada data, set ke default
          this.setDefaultSmartMarketingData();
        }
      } else if (
        response &&
        response.get("data") &&
        response.get("data").size > 0
      ) {
        // Response normal tanpa error
        const apiData = response.get("data").get(0);
        this.setSmartMarketingData(apiData);
      } else {
        // Jika tidak ada data sama sekali
        this.setDefaultSmartMarketingData();
      }
    } catch (error) {
      toast.error("Failed to fetch smart marketing data");
      this.setDefaultSmartMarketingData();
    }
  }

  setDefaultSmartMarketingData() {
    this.setState({
      dataSmartMarketing: fromJS({
        marketing_messages_sent: 0,
        marketing_messages_delivered: 0,
        marketing_messages_read: 0,
        marketing_messages_link_btn_click: 0,
        marketing_messages_delivery_rate: 0,
        marketing_messages_read_rate: 0,
        marketing_messages_link_btn_click_rate: 0,
        marketing_messages_read_rate_benchmark: 0,
        marketing_messages_click_rate_benchmark: 0,
        marketing_messages_similar_template_rate: 0,
        unique_clicks: 0,
      }),
      loaderStyle: { display: "none" },
    });
  }

  setSmartMarketingData(apiData) {
    this.setState({
      dataSmartMarketing: fromJS({
        marketing_messages_sent: apiData.get("marketing_messages_sent") || 0,
        marketing_messages_delivered:
          apiData.get("marketing_messages_delivered") || 0,
        marketing_messages_read: apiData.get("marketing_messages_read") || 0,
        marketing_messages_link_btn_click:
          apiData.get("marketing_messages_link_btn_click") || 0,
        marketing_messages_delivery_rate:
          apiData.get("marketing_messages_delivery_rate") || 0,
        marketing_messages_read_rate:
          apiData.get("marketing_messages_read_rate") || 0,
        marketing_messages_link_btn_click_rate:
          apiData.get("marketing_messages_link_btn_click_rate") || 0,
        marketing_messages_read_rate_benchmark:
          apiData.get("marketing_messages_read_rate_benchmark") || 0,
        marketing_messages_click_rate_benchmark:
          apiData.get("marketing_messages_click_rate_benchmark") || 0,
        marketing_messages_similar_template_rate:
          apiData.get("marketing_messages_similar_template_rate") || 0,
        unique_clicks: apiData.get("unique_clicks") || 0,
      }),
      loaderStyle: { display: "none" },
    });
  }

  handleCallback(start, end, label) {
    // Konversi ke moment object jika diperlukan
    const startMoment = moment(start);
    const endMoment = moment(end);

    // Validasi bahwa range tidak melebihi 7 hari
    const diffDays = endMoment.diff(startMoment, 'days');
    if (diffDays > 6) {
      toast.warn("Date range cannot exceed 7 days");
      return;
    }

    // Validasi bahwa tanggal tidak melebihi hari ini
    if (endMoment.isAfter(moment(), 'day')) {
      toast.warn("End date cannot be in the future");
      return;
    }

    // Validasi bahwa tanggal tidak kurang dari 7 hari yang lalu
    if (startMoment.isBefore(moment().subtract(6, 'days'), 'day')) {
      toast.warn("Start date cannot be more than 7 days ago");
      return;
    }

    var starts = startMoment.format("MM/D/YYYY");
    var ends = endMoment.format("MM/D/YYYY");
    var dated = startMoment.format("D MMMM YYYY") + " - " + endMoment.format("D MMMM YYYY");

    // Update form dengan tanggal yang dipilih
    var formVal = this.state.form;
    formVal = formVal.set("tanggal-mulai", starts).set("tanggal-selesai", ends);

    this.setState({
      dates: dated,
      form: formVal,
    });
  }

  async componentDidMount() {
    var isAdmin = await this.props.actionFindByGroupId();
    this.setState({ isadmin: isAdmin });

    if (PrevilageId > 1 && isAdmin == false) {
      this.setState({ hideclient: "hide", colhide: "forms-groups cols-sm-6" });
    } else {
      this.setState({ hideclient: "", colhide: "forms-groups cols-sm-4" });
    }
    this.props.actionGetClient();
    this.props.actionGetAllSender(ClientId);
    await this.props.actionGetAccessModule(PrevilageId);
    let restrict = this.handleActionId();
    let dissen = this.state.dissender;
    if (restrict == 5) {
      this.props.actionFetchTemplate(ClientId, SenderId, 5);
      dissen = true;
    } else dissen = false;
    this.props.actionFetchTemplate(ClientId, SenderId);
    
    this.setState({
      dissender: dissen,
      actionid: restrict,
      loaderStyle: { display: "none" },
    });

    // Refresh DateRangePicker setelah component mounted
    setTimeout(() => {
      this.refreshDateRangePicker();
    }, 100);
  }

  // Force refresh DateRangePicker
  refreshDateRangePicker = () => {
    // Force re-render dengan mengubah key atau state
    this.setState({ 
      datePickerKey: Date.now(),
      currentDate: moment().format('YYYY-MM-DD')
    });
  };

  render() {
    const { title, loaderStyle, dataSmartMarketing } = this.state;
    const { form, errors } = this.state;

    const innerStyle = {
      display: "flex",
      gap: "20px",
    };

    const rateGroupStyle = {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    };

    const rateStyle = {
      fontSize: "28px",
      fontWeight: "bold",
    };

    const labelStyle = {
      fontSize: "14px",
      color: "#555",
    };

    return (
      <div>
        <div className="page-loader-wrapper" style={loaderStyle}>
          <div className="loader">
            <div className="preloader">
              <div className="spinner-layer pl-orange">
                <div className="circle-clipper left">
                  <div className="circle"></div>
                </div>
                <div className="circle-clipper right">
                  <div className="circle"></div>
                </div>
              </div>
            </div>
            <p>Please wait...</p>
          </div>
        </div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="rows mb-4">
              <div className="cols-sm-12">
                <h1 className="m-0 titles-card-head">
                  Smart Marketing Dashboard
                </h1>
              </div>
            </div>            <div className="rows mb-2">
              <div className={this.state.colhide}>
                <DateRangePicker
                  key={this.state.datePickerKey}
                  initialSettings={{
                    startDate: moment(),
                    endDate: moment(),
                    minDate: moment().subtract(6, "days"),
                    maxDate: moment(),
                    opens: "left",
                    drops: "down",
                    autoUpdateInput: true,
                    alwaysShowCalendars: true,
                    showCustomRangeLabel: true,
                    linkedCalendars: false,
                    maxSpan: {
                      days: 7
                    },
                    locale: {
                      format: "MM/DD/YYYY",
                      separator: " - ",
                      applyLabel: "Apply",
                      cancelLabel: "Cancel",
                      fromLabel: "From",
                      toLabel: "To",
                      customRangeLabel: "Custom Range",
                      daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                      monthNames: [
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ],
                      firstDay: 1
                    },
                    ranges: {
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [
                        moment().subtract(6, "days"),
                        moment(),
                      ],
                    },
                  }}
                  onCallback={this.handleCallback}
                >
                  <div
                    className={`cols-sm-12 floats-right calendar ${
                      errors.has("tanggal-mulai") ||
                      errors.has("tanggal-selesai")
                        ? "error"
                        : ""
                    }`}
                  >
                    <i className="fa fa-calendar"></i>&nbsp;&nbsp;
                    <span>{this.state.dates}</span>{" "}
                    <i className="fa fa-caret-down"></i>
                  </div>
                </DateRangePicker>
              </div>
              <div
                className={`forms-groups cols-sm-2 right ${this.state.hideclient}`}
              >
                <ComboboxInput
                  field="client"
                  value={form.get("client")}
                  options={fromJS({
                    source: this.props.clientall,
                    value: "client-id",
                    label: "client-name",
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Client"
                  disabled={this.state.dissender}
                  hasError={errors.has("client")}
                />
              </div>
              <div className="forms-groups cols-sm-2 floats-right">
                <ComboboxInput
                  field="sender"
                  value={form.get("sender")}
                  options={fromJS({
                    source: this.props.senderall,
                    value: "sender-id",
                    label: "sender-id-name",
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Sender"
                  disabled={this.state.dissender}
                  hasError={errors.has("sender")}
                />
              </div>
              <div className="forms-groups cols-sm-2 floats-right">
                <ComboboxInput
                  field="template-id"
                  value={form.get("template-id")}
                  options={fromJS({
                    source: this.props.templates,
                    value: "template-id",
                    label: "template-name",
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Template"
                  disabled={this.state.dissender}
                  hasError={errors.has("template-id")}
                />
              </div>
              <div className="forms-groups cols-sm-2 floats-right">
                <button
                  type="button"
                  // disabled={!form.get("upload-completed")}
                  style={{ height: "40px" }}
                  className="btn btn-width btn-success"
                  onClick={this.handleSearch}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="rows">
              <div className="cols-lg-12">
                <div className="content-header">
                  <div className="rows mb-2">
                    <div className="cols-sm-12">
                      <h1 className="m-0 titles-card-child">
                        Smart Marketing Summary
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-3" id="p1">
                    <div className="small-box blue">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get("marketing_messages_sent")}
                        </h3>
                        <p className="titles-card-child2">Sent Messages</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-3 " id="p2">
                    <div className="small-box red">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get(
                            "marketing_messages_delivered"
                          )}
                        </h3>
                        <p className="titles-card-child2">Delivered Messages</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-3 " id="p3">
                    <div className="small-box orange">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get("marketing_messages_read")}
                        </h3>
                        <p className="titles-card-child2">Read Messages</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-3 " id="p4">
                    <div className="small-box yellow">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get(
                            "marketing_messages_link_btn_click"
                          )}
                        </h3>
                        <p className="titles-card-child2">Button Link Click</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="rows">
              <div className="cols-lg-12">
                <div className="content-header">
                  <div className="rows mb-2">
                    <div className="cols-sm-12">
                      <h1 className="m-0 titles-card-child">Button Click</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12" id="p1">
                    <div className="small-box white">
                      <div className="inner">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Click Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>URL_Button</td>
                              <td>
                                {dataSmartMarketing.get(
                                  "marketing_messages_link_btn_click"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>Unique_URL_Button</td>
                              <td>{dataSmartMarketing.get("unique_clicks")}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="rows">
              <div className="cols-lg-12">
                <div className="content-header">
                  <div className="rows mb-2">
                    <div className="cols-sm-12">
                      <h1 className="m-0 titles-card-child">Rates</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-4" id="p1">
                    <div className="small-box blue">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get(
                            "marketing_messages_delivery_rate"
                          )}
                          %
                        </h3>
                        <p className="titles-card-child2">Delivery Rate</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-4 " id="p2">
                    <div className="small-box red">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get(
                            "marketing_messages_read_rate"
                          )}
                          %
                        </h3>
                        <p className="titles-card-child2">Read Rate</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-4 " id="p3">
                    <div className="small-box orange">
                      <div className="inner">
                        <h3>
                          {dataSmartMarketing.get(
                            "marketing_messages_link_btn_click_rate"
                          )}
                          %
                        </h3>
                        <p className="titles-card-child2">Button Click Rate</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="rows">
              <div className="cols-lg-12">
                <div className="content-header">
                  <div className="rows mb-2">
                    <div className="cols-sm-12">
                      <h1 className="m-0 titles-card-child">Benchmarks</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6" id="p1">
                    <div className="small-box white">
                      <div className="inner" style={innerStyle}>
                        <div style={rateGroupStyle}>
                          <h3 style={rateStyle}>{dataSmartMarketing.get("marketing_messages_read_rate_benchmark")}%</h3>
                          <p className="titles-card-child2" style={labelStyle}>Read Rate</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-6 " id="p2">
                    <div className="small-box white">
                      <div className="inner" style={innerStyle}>
                        <div style={rateGroupStyle}>
                          <h3 style={rateStyle}>{dataSmartMarketing.get("marketing_messages_click_rate_benchmark")}%</h3>
                          <p className="titles-card-child2" style={labelStyle}>Click Rate</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      isLoggedIn: state.auth.isLoggedIn,
      senderall: state.user.senders,
      homepushsummary: state.user.homepushsummary,
      getdailymessagebystatus: state.user.getdailymessagebystatus,
      getreadratebyday: state.user.getreadratebyday,
      getpushformatdistribution: state.user.getpushformatdistribution,
      templates: state.user.templateall,
      getbacthname: state.user.getbacthname,
      gethighestreadrate: state.user.gethighestreadrate,
      accessmodules: state.user.accessmodules,
      clientall: state.user.clientall,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        actionGetAccessModule: ActionGetAccessModule,
        actionGetAllSender: ActionGetAllSender,
        actionGetSmartMarketing: ActionGetSmartMarketing,
        actionFetchTemplate: ActionFetchTemplate,
        actionGetClient: ActionGetClient,
        actionFindByGroupId: ActionFindByGroupId,
      },
      dispatch
    )
)(Page);
